import React from "react";
import "./home.css";
import hotelbanner from "./../../assets/hotelinside.png";
import face1 from "../../assets/face1.png";
import face2 from "../../assets/face2.png";
import face3 from "../../assets/face3.png";
import face4 from "../../assets/face4.png";
import face5 from "../../assets/face5.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBed, faBellConcierge, faCartFlatbedSuitcase, faCalendar, faEnvelope, faLocationDot, faPhone, faSpa, faSquareParking, faUtensils, faWaterLadder, faWifi } from '@fortawesome/free-solid-svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';
import { Link } from "react-router-dom";

const Home = () => {

    const isSafari = navigator.vendor.includes('Apple');

    const dateSelect = () =>{
        alert("Dates in Safari will be selected on the preferred booking site!")
    }

    return(
    <div>

        <section>
            <div id="firstsection"> 
                <div id="firstdiv">
                    <h1>HOTEL <br /> & RESORTS</h1>
                    <p>Feel the luxury and the comfort that our luxurius resort offers.</p>
                    <button className="bookbutton">Learn more</button>
                </div>

                <div id="outline" data-aos="zoom-in" data-aos-duration="1000"></div>

                <img src={hotelbanner}  data-aos="fade-in" alt="" />
            </div>

            <div id="quickbook">
                    <div id="checkin">
                        <h2>Check-in</h2>
                        <div className="caldiv">

                    {isSafari ? (<>
                        <FontAwesomeIcon icon={faCalendar} className="calicon" onClick={dateSelect} /> 
                        <h3 onClick={dateSelect}>01/01/2023</h3>
                        </>
                    ) : (
                        <input type="date" defaultValue="2023-01-01" name="" id="" />  
                    )}

                                                      
                        </div>
                    </div>
                    <div id="checkout">
                        <h2>Check-out</h2>
                        <div className="caldiv">
                    {isSafari ? (<>
                        <FontAwesomeIcon icon={faCalendar} className="calicon" onClick={dateSelect} /> 
                        <h3 onClick={dateSelect}>01/01/2024</h3>
                        </>
                    ) : (
                        <input type="date" defaultValue="2024-01-01" name="" id="" />    
                    )}
                                               
                        </div>
                    </div>
                    <div id="nrperson">
                        <h2>Guests</h2>                     
                            <select>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                            </select>
                    </div>
                    <div id="buttondiv">
                        <a href="https://booking.com"><button>Book now</button></a>
                    </div>
                </div>
        </section><br /><br /><br /><br /><br /><br />


        <h1 className="headingtext" id="factext">Our facilities</h1>

        <section id="facilities">
            <div data-aos="zoom-in" data-aos-duration="200">
            <FontAwesomeIcon className="facicon bluebg" icon={faUtensils} />
            <h3>Restaurant</h3>
            </div>
            <div data-aos="zoom-in" data-aos-delay="100" data-aos-duration="200">
            <FontAwesomeIcon className="facicon bluebg" icon={faWifi} />
            <h3>Free Wifi</h3>
            </div>
            <div data-aos="zoom-in" data-aos-delay="200" data-aos-duration="200">
            <FontAwesomeIcon className="facicon bluebg" icon={faCartFlatbedSuitcase} />
            <h3>Luggage Assistance</h3>
            </div>
            <div data-aos="zoom-in" data-aos-delay="300" data-aos-duration="200">
            <FontAwesomeIcon className="facicon bluebg" icon={faSquareParking} />
            <h3>Parking</h3>
            </div>
            <div data-aos="zoom-in" data-aos-delay="300" data-aos-duration="200">
            <FontAwesomeIcon className="facicon" icon={faWaterLadder} />
            <h3>Pool</h3>
            </div>
            <div data-aos="zoom-in" data-aos-delay="200" data-aos-duration="200">
            <FontAwesomeIcon className="facicon" icon={faBellConcierge} />
            <h3>Reception 24h</h3>
            </div>
            <div data-aos="zoom-in" data-aos-delay="100" data-aos-duration="200">
            <FontAwesomeIcon className="facicon" icon={faBed} />
            <h3>Comfortable suits</h3>
            </div>
            <div data-aos="zoom-in" data-aos-duration="200">
            <FontAwesomeIcon className="facicon" icon={faSpa} />
            <h3>SPA</h3>
            </div>
        </section>

        <h1 className="headingtext" id="roomtext">Pick your favourite suite</h1>

        <section id="roomslider">
            <div id="room1">
                <h2>Double Luxury Suite</h2>
                <p>A two person elegant room. Taste the beauty and feel the calmness of our precious room.</p>
                <Link to="/rooms"><button className="roomdetails">Room details</button></Link>
            </div>
            <div id="room2">
                <h2>Triple Luxury Suite</h2>
                <p>Big, spacious and relaxing suite. The most spacious ambient of ours offers you a pleasant stay.</p>
                <Link to="/rooms"><button className="roomdetails">Room details</button></Link>
            </div>
            <div id="room3">
                <h2>Twin Luxury Suite</h2>
                <p>Modern and attractive design. Our high-quality standards guarantee a relaxing holiday.</p>
                <Link to="/rooms"><button className="roomdetails">Room details</button></Link>
            </div>
        </section>

        <h1 class="headingtext" id="testtext">What our guests say</h1>

        <section id="testimonials">
        <Swiper
        breakpoints={{
            768: {
            width: 1300,
            slidesPerView: 3,
            },
            }}
        cssMode={true}
        navigation={true}
        pagination={true}
        mousewheel={true}
        keyboard={true}
        slidesPerView={1}
        modules={[Navigation, Pagination, Mousewheel, Keyboard]}
        className="mySwiper"
      >
        <SwiperSlide>
            <div className="testdiv">
                <img src={face1} alt="" />
                <h3>John Doe</h3>
                <h5>Kosovo</h5>
                <p><span className="quotationmarks">"</span>Our recent stay at AEA Hotel was truly captivating. The unique ambiance, top-notch service, and the breathtaking view from our room made our visit absolutely memorable. We're looking forward to returning to relive this incredible experience!<span className="quotationmarks">"</span></p>
            </div>
        </SwiperSlide>
        <SwiperSlide>
            <div className="testdiv">
                <img src={face2} alt="" />
                <h3>John Doe</h3>
                <h5>Albania</h5>
                <p><span className="quotationmarks">"</span>Our experience at AEA was truly exceptional. The captivating ambiance, impeccable service, and the breathtaking view from our room made our time there truly remarkable. We're eagerly looking forward to our next visit to relive this extraordinary experience.<span className="quotationmarks">"</span></p>
            </div>
        </SwiperSlide>
        <SwiperSlide>
            <div className="testdiv">
                <img src={face3} alt="" />
                <h3>John Doe</h3>
                <h5>North Macedonia</h5>
                <p><span className="quotationmarks">"</span>The holidays at your hotel were absolutely unforgettable. The unique ambiance, impeccable service, and the captivating view from our room made our time there truly exceptional. We're already looking forward to returning for another fascinating stay!<span className="quotationmarks">"</span></p>
            </div>
        </SwiperSlide>
        <SwiperSlide>
            <div className="testdiv">
                <img src={face4} alt="" />
                <h3>Jane Doe</h3>
                <h5>Montenegro</h5>
                <p><span className="quotationmarks">"</span>My trip to AEA was truly remarkable. The captivating ambiance, exceptional service, and the breathtaking view from our room made our time there incredibly memorable. We're already looking forward to returning for another intriguing experience.<span className="quotationmarks">"</span></p>
            </div>
        </SwiperSlide>
        <SwiperSlide>
            <div className="testdiv">
                <img src={face5} alt="" />
                <h3>John Doe</h3>
                <h5>USA</h5>
                <p><span className="quotationmarks">"</span>During our time at the hotel, we had a truly remarkable experience.. The captivating ambiance, impeccable service, and the stunning view from our room made our experience incredibly special. We're eager to return!<span className="quotationmarks">"</span></p>
            </div>
        </SwiperSlide>
        
      </Swiper>
        </section>

        <h1 class="headingtext" id="amenitiestext">Make the most of your stay</h1>

        <section id="amenities">
            <div id="am1">
                <h1>Pool</h1>
                <Link to="/gallery"><button className="roomdetails">View more</button></Link>
            </div>
            <div id="am2">
                <h1>Restaurant</h1>
                <Link to="/gallery"><button className="roomdetails">View more</button></Link>
            </div>
            <div id="am3">
                <h1>Gym</h1>
                <Link to="/gallery"><button className="roomdetails">View more</button></Link>
            </div>
            <div id="am4">
                <h1>Conference Hall</h1>
                <Link to="/gallery"><button className="roomdetails">View more</button></Link>
            </div>
        </section>

        <section id="contactsection">
            <div id="contacttext">
                <div>
                    <h1>Contact us</h1>
                    <h3>Get in touch with us by calling us or writing a message. Our staff will reply to you as soon as possible.</h3>
                </div>
                <div>
                    <div><FontAwesomeIcon className="contacticons" icon={faPhone} /><h2>+383 44 233 821</h2></div>
                    <div><FontAwesomeIcon className="contacticons" icon={faEnvelope}/><h2>info@hotel.com</h2></div>
                    <div><FontAwesomeIcon className="contacticons" icon={faLocationDot} /><h2>Rr. Filan Festeku p.n</h2></div>
                </div>
            </div>
            <div id="contactinfo">
                <h1>Leave a message</h1>
                <input type="text" name="" id="contactname" placeholder="Name"/>
                <input type="text" name="" id="contactsubject" placeholder="Subject"/>
                <textarea name="" id="contactmessage" placeholder="Message"></textarea>
                <input type="submit" name="" id="contactsubmit" value="Send" />
            </div>
        </section>

    </div>
    )

}

export default Home